<template>
  <v-dialog v-model="visible" max-width="638" persistent>
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span v-if="kind === 'off'" class="v-dialog--custom__title">{{ $t(`${namespace}.off.title`) }}</span>
        <span v-if="kind === 'on'" class="v-dialog--custom__title">{{ $t(`${namespace}.on.title`) }}</span>

        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          @click.native="close(true)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4 pt-0 pb-5">
        <span v-if="kind === 'off'" v-html="$t(`${namespace}.off.text`)" class="gray-6--text" />
        <span v-if="kind === 'on'" v-html="$t(`${namespace}.on.text`)" class="gray-6--text" />
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer/>

        <a
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="close(true)"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          color="accent"
          depressed
          round
          @click.native="handleConfirmChange"
        >
          {{ $t('Common.proceed') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FlexibleBenefitConfirmDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    kind: {
      type: String,
      default: 'on'
    }
  },
  data () {
    return {
      namespace: 'Components.FlexibleBenefitConfirmDialog'
    }
  },
  methods: {
    close (reset = null) {
      if (this.kind === 'on' && reset) {
        this.$emit('close', {
          reset: true,
          tab: null
        })
      }

      if (this.kind === 'off') {
        this.$emit('close', {
          reset: true,
          tab: 'creditPolicyTab2'
        })
      }
    },

    handleConfirmChange () {
      if (this.kind === 'on') {
        this.$emit('confirm', {
          reset: true,
          tab: 'creditPolicyTab2'
        })
      }

      if (this.kind === 'off') {
        this.$emit('confirm', {
          reset: true,
          tab: 'creditPolicyTab1'
        })
      }
    }
  }
}
</script>
